<template>
  <div class="layout-wrap">
    <Loading />
    <ToExternalPlanInfoDialog/>
    <div class="front-wrap">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'EmptyLayout',
}
</script>

<script setup lang="ts">
  import { defineAsyncComponent } from 'vue'
  import { useKuradenStatusStore } from '@/stores/kuradenStatus'

  // 蔵電ストアの初期化（受電ダイアログ・通話状態監視）
  useKuradenStatusStore()

  // components
  const ToExternalPlanInfoDialog = defineAsyncComponent(() => import('@/components/cloud/notification/ToExternalPlanInfoDialog.vue'))
  const Loading = defineAsyncComponent(() => import('@/components/ui/Loading.vue'))
</script>

<style scoped>
.layout-wrap {
  height: 100%;
}
</style>